export default {
    filtersUpdated: 'filters-updated',
    searchTermUpdated: 'search-term-updated',
    statusUpdated: 'status-updated'
}